import { Routes } from '@angular/router';
import { NotFound404Component } from './not-found.component';


const NotFoundRoutes: Routes = [{
    path: '',
    component: NotFound404Component,
    data: {
      title: 'Sorry content not found'
    }
}];


export default NotFoundRoutes;